import React, { FC } from 'react'
import { SlugifiedAttributesFilterItemWithValues } from 'services/providers/bapi/entities/filters/normalize'
import { useAttributesFilterProps } from 'sharedComponents/ProductStream/filters/useAttributesFilterProps'
import styled from 'styled-components'
import { FilterCheckboxItem } from 'uiComponents/organisms/Filters/FilterGeneralGroup'
import UnfoldingFilterBox from 'uiComponents/organisms/Filters/UnfoldingFilterBox'
import {
  useTrackOnCloseFilter,
  useTrackOnOpenFilter,
} from '../../../../helpers/tracking/hooks/trackFilter'

const ListWrapper = styled.div`
  max-height: 360px;
  overflow-y: auto;
`

const GenericFilter: FC<{
  filter: SlugifiedAttributesFilterItemWithValues
}> = ({ filter }) => {
  const { options, selectedValues, toggleSelection, onReset } =
    useAttributesFilterProps(filter)
  const onCloseFilterTracking = useTrackOnCloseFilter()
  const onOpenFilterTracking = useTrackOnOpenFilter()
  const trackOnClose = () => {
    onCloseFilterTracking(filter.slug, 'quick_filters')
  }
  const trackOnOpen = () => {
    onOpenFilterTracking(filter.slug, 'quick_filters')
  }
  return (
    <UnfoldingFilterBox
      label={filter.name}
      key={filter.slug}
      dataTestId={`Generic_Filter_${filter.slug}`}
      activeFiltersCount={selectedValues.length}
      onReset={onReset}
      styledContentStyles={{ padding: '24px' }}
      onClose={trackOnClose}
      onOpen={trackOnOpen}
    >
      <ListWrapper data-testid="FilterValues">
        {options.map((filterValue, index) => (
          <FilterCheckboxItem
            key={filterValue.id}
            id={filterValue.id}
            index={index}
            isListCollapsed={false}
            checked={selectedValues.includes(filterValue.id)}
            toggleSelection={toggleSelection}
            name={filterValue.name}
            singleColumn={true}
          />
        ))}
      </ListWrapper>
    </UnfoldingFilterBox>
  )
}

export default GenericFilter
